import { FC, useMemo } from 'react';
import { Box, VStack, Heading, StackDivider, Flex } from '@chakra-ui/layout';
import { Text, Image } from '@chakra-ui/react';
import pinchIllustration from 'illustrations/pinch.svg';
import moveIllustration from 'illustrations/move.svg';
import rotateIllustration from 'illustrations/rotate.svg';
import zoomIllustration from 'illustrations/zoom.svg';
import mouseRotateIllustration from 'illustrations/mouse-rotate.svg';
import mouseMoveIllustration from 'illustrations/mouse-move.svg';

import { isTouchDevice } from 'utils/device';
import { FiX } from 'react-icons/fi';

type Props = {
  close: () => void;
};

const Controls: FC<Props> = ({ close }) => {
  const isTouch = useMemo(() => isTouchDevice(), []);
  return (
    <Box
      m={4}
      p={[4, 4, 8]}
      top={16}
      bottom={0}
      left={0}
      right={isTouch ? 0 : undefined}
      width={isTouch ? undefined : '280px'}
      overflowY='auto'
      borderRadius='md'
      bg='whiteAlpha.100'
      position='absolute'
      backdropFilter='blur(100px)'
      zIndex={1}
      sx={{
        '::-webkit-scrollbar': {
          width: '20px'
        },
        '::-webkit-scrollbar-track': {
          backgroundColor: 'transparent'
        },
        '::-webkit-scrollbar-thumb': {
          backgroundColor: 'whiteAlpha.300',
          borderRadius: '20px',
          border: '6px solid transparent',
          backgroundClip: 'content-box'
        }
      }}
    >
      <VStack textAlign='left' alignItems='stretch' divider={<StackDivider />}>
        <Heading
          size='lg'
          as={Flex}
          justifyContent='space-between'
          alignItems='center'
        >
          Controls{' '}
          <Box onClick={close} as={FiX} _hover={{ cursor: 'pointer' }} />
        </Heading>

        {isTouch && (
          <VStack spacing='40px' mt={5} alignItems='stretch'>
            <ControlExplainer iconSrc={pinchIllustration} text='In/Out' />
            <ControlExplainer iconSrc={moveIllustration} text='move around' />
            <ControlExplainer iconSrc={rotateIllustration} text='Rotate' />
          </VStack>
        )}

        {!isTouch && (
          <VStack spacing='40px' mt={5} alignItems='stretch'>
            <ControlExplainer iconSrc={zoomIllustration} text='zoom' />
            <ControlExplainer
              iconSrc={mouseMoveIllustration}
              text='move around'
            />
            <ControlExplainer iconSrc={mouseRotateIllustration} text='Rotate' />
          </VStack>
        )}
      </VStack>
    </Box>
  );
};

const ControlExplainer = (props: { iconSrc: string; text: string }) => {
  return (
    <Flex justifyContent='space-between' alignItems='center' width='100%'>
      <Image
        src={props.iconSrc}
        height='64px'
        htmlHeight='64px'
        ignoreFallback
        alt='control'
      />
      <Text
        ml='4'
        fontWeight='extrabold'
        textAlign='right'
        fontSize='md'
        children={props.text}
      />
    </Flex>
  );
};

export default Controls;
